var exports = {
  "MI": "ErrorPage404__Fuau1R",
  "mc": "Container__D14oXP",
  "$n": "Button__IXe7ta",
  "Nj": "Auth__gGVsn7",
  "rR": "SearchLabel__lFq32q",
  "s7": "SearchContainer__TWGDhv",
  "B9": "SearchForm__MSUX8D",
  "gu": "Logo__ci0SNW",
  "nc": "LogoImg2x__FGUXFn",
  "Uh": "LogoImg1x__82fZBB",
  "CJ": "Suggestions__VQECUM",
  "X9": "ParallaxWrapper__rnTiXH",
  "Cr": "ParallaxField__a-dBSt",
  "RE": "ParallaxBg__a-Xo8b",
  "Cw": "ParallaxIllustration__mPo9vH",
  "$U": "ParallaxErrorText__WG4av7",
  "vW": "ParallaxOctocat__b87GAR",
  "_9": "ParallaxSpeeder__VggkxT",
  "h5": "ParallaxOctocatShadow__IR8v3S",
  "S5": "ParallaxSpeederShadow__FChFmo",
  "p": "ParallaxBuilding1__sZwiWQ",
  "is": "ParallaxBuilding2__Er8IiX",
  "DO": "SearchInput__igDyZ4",
};

module.exports = exports;
